import { render, staticRenderFns } from "./SelfSelect.vue?vue&type=template&id=4d82931d&scoped=true"
import script from "./SelfSelect.vue?vue&type=script&lang=js"
export * from "./SelfSelect.vue?vue&type=script&lang=js"
import style0 from "./SelfSelect.vue?vue&type=style&index=0&id=4d82931d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d82931d",
  null
  
)

export default component.exports